import * as React from 'react';

export function useFolderName(initialRenameFolderName: string) {
  const [folderName, setFolderName] = React.useState('');

  /**
   * because the dialog doesn't get detached from the view.
   * make sure that folder name is reset when this modal is closed
   **/
  React.useEffect(() => {
    setFolderName(initialRenameFolderName);
  }, [initialRenameFolderName]);

  return [folderName, setFolderName] as const;
}
